import { Component, ElementRef, ViewChild } from '@angular/core';
import { DialogRef, DialogBase, DialogService, HotkeyService, Key, tr } from '@kpd/framework-ngx';
import { ChangePasswordFormgroupComponent } from 'app/shared/components/change-password/change-password-formgroup.component';
/*

 */

export interface ChangePasswordDialogData {
  header?: string;
  verifyButtonText?: string;
  cancelButtonText?: string;
  userKey: Key<string>;
  localUser: boolean;
}

@Component({
  selector: 'app-change-password-dialog',
  templateUrl: './change-password-dialog.component.html',
})
export class ChangePasswordDialogComponent extends DialogBase {
  static key = 'changePassword';

  saved = false;
  cancelLabel = tr('Cancel');
  verifyLabel = tr('Save');
  userKey: Key<string>;
  loading = false;
  severityColor = '';
  localUser = false;

  @ViewChild(ChangePasswordFormgroupComponent, { static: false })
  changePasswordFormGroupComponent: ChangePasswordFormgroupComponent;

  constructor(dialogService: DialogService, element: ElementRef, hotKeyService: HotkeyService) {
    super(ChangePasswordDialogComponent.key, dialogService, element, hotKeyService);
  }

  onBeforeShow(dialogRef: DialogRef): void {
    this.saved = false;
    this.severityColor = '';
    const data = dialogRef.data as ChangePasswordDialogData;
    if (data.header) {
      this.header = data.header;
    }
    if (data.verifyButtonText) {
      this.verifyLabel = data.verifyButtonText;
    }
    if (data.cancelButtonText) {
      this.cancelLabel = data.cancelButtonText;
    }
    if (data.userKey) {
      this.userKey = data.userKey;
    }
    if (data.localUser) {
      this.localUser = data.localUser;
    }
  }

  onPasswordChanged(): void {
    this.saved = true;
    this.severityColor = 'success';
  }

  onSubmit(): void {
    this.changePasswordFormGroupComponent.onSubmit();
  }
}
